import validator from 'validator';
import MomentUtil from '../../app/util/DateMomentUtil';
import UtfCode from '../../app/util/UtfCode';

// validtor
// Quelle:
// https://github.com/validatorjs/validator.js

const existValue = (value: any) => !!value;

const isBlank = (value: any) => {
    if (!existValue(value)) {
        return true;
    }

    if (value !== undefined) {
        return validator.isEmpty(value, { ignore_whitespace: true });
    }

    return false;
}

const isBooleanTrue = (value?: boolean) => value === true;




const isDate = (date?: string) => {
    if (date === undefined) {
        return false;
    }

    return MomentUtil.parseLocalDate(date).isValid();
}

const isDateSameOrAfterNow = (date?: string) => {
    if (date === undefined) {
        return false;
    }

    // https://momentjs.com/docs/#/parsing/string-format/
    return MomentUtil.parseLocalDate(date).isSameOrAfter(MomentUtil.startOfDayNow());
}

const isDateSameOrAfter = (date?: string, compare?: string) => {
    if (date === undefined || compare === undefined) {
        return false;
    }

    // https://momentjs.com/docs/#/parsing/string-format/
    return MomentUtil.parseLocalDate(date).isSameOrAfter(MomentUtil.parseLocalDate(compare));
}

// check if the string contains only numbers.
const isNumeric = (value?: string) => {
    if (value === undefined) {
        return false;
    }

    return validator.isNumeric(value);
}

const isLength = (value: string, min: number, max: number) => {
    const v = value.split(UtfCode.SPACE).join('').trim();
    return validator.isLength(v, { max, min });
}

// check if the string is an email.
const isEmail = (value?: string) => {
    if (value === undefined) {
        return false;
    }
    /**
     * options is an object which defaults to 
     * { allow_display_name: false, require_display_name: false, allow_utf8_local_part: true, 
     * require_tld: true, allow_ip_domain: false, domain_specific_validation: false, blacklisted_chars: '' }. 
     * 
     * If allow_display_name is set to true, the validator will also match Display Name <email-address>. 
     * If require_display_name is set to true, the validator will reject strings without the format Display Name <email-address>. 
     * If allow_utf8_local_part is set to false, the validator will not allow any non-English UTF8 character in email address' local part. 
     * If require_tld is set to false, e-mail addresses without having TLD in their domain will also be matched. 
     * If ignore_max_length is set to true, the validator will not check for the standard max length of an email. 
     * If allow_ip_domain is set to true, the validator will allow IP addresses in the host part. 
     * If domain_specific_validation is true, some additional validation will be enabled, 
     * e.g. disallowing certain syntactically valid email addresses that are rejected by GMail. 
     * If blacklisted_chars receives a string, then the validator will reject emails that include any of the characters in the string, in the name part.
     */
    return validator.isEmail(value);
}

const InputValidator = {
    existValue,
    isBlank,
    isBooleanTrue,
    isDate,
    isDateSameOrAfterNow,
    isDateSameOrAfter,
    isNumeric,
    isEmail,
    isLength
}

export default InputValidator;
